import React from 'react';
import Grid from '@mui/material/Grid2';
import Popup from '../Popup';

export default function RemoveFormPopup(props) {
	return (
		<Popup
			closeButton
			onClose={() => props.onClose(false)}
			title={props.lan.removeForm}
			icon='alert-icon.svg'
			buttonText={props.lan.remove}
			buttonOnClick={() => props.removeFormTask()}
		>
      <Grid container>
        <Grid size={12} className='mt-2 Fielder-pink-color'>
          {props.lan.removeFormWarning}
        </Grid>
      </Grid>
		</Popup>
	);
}
